module.exports = function () {
	$('.search-bar__close-cta').click(function () {
		$('#A1-header').removeClass('has-search-active');
	});

	var $container = $('.search-dropdown');

	if ($container.length) {
		var typeAheadObject = Innophos.Modules.SitewideSearchBar.TypeAhead($container);
		Innophos.Modules.SitewideSearchBar.TypeAheadDropdown($container);
		Innophos.Modules.SitewideSearchBar.StripSpecialCharacters();


		var setClearButtonVisibility = function (inputValue) {
			if (inputValue) {
				$('.search-dropdown .search-bar__reset').addClass('search-bar__reset--visible');
			} else {
				$('.search-dropdown .search-bar__reset').removeClass('search-bar__reset--visible');
				typeAheadObject.clearTypeAhead();
			}
		};

		$('.search-dropdown .search-bar__input').keyup(function () {
			setClearButtonVisibility($(this).val());
		});

		$('.search-dropdown .search-bar__reset').click(function () {
			setClearButtonVisibility();
		});
	}

	var $searchInput = $('.search-dropdown .search-bar__input');
	var $searchInner = $('.search-dropdown .search-bar__inner');
	var searchInnerActiveClass = 'has-suggestions';

	$searchInput.focusout(function () {
		$searchInner.removeClass(searchInnerActiveClass);
	});

	$searchInput.focus(function () {
		var currentVal = $(this).val();

		if (!currentVal.length) {
			$searchInner.addClass(searchInnerActiveClass);
		}
		else {
			$searchInner.removeClass(searchInnerActiveClass);
		}
	});
};
